import AxiosInstance from "./api";

export const SummaryOfDetailedService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/summary-of-detailed/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/summary-of-detailed/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/summary-of-detailed", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/summary-of-detailed/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/summary-of-detailed/" + id);
  },
};
